export default __webpack_public_path__ + "static/media/testimonial.b0c275f2.png";